import i18n from "i18n";
const capabilityLabel = (title) => i18n.t(`permissions.capabilities.${String(title).toLowerCase()}`, { ns: "users", defaultValue: title });
export default capabilityLabel;
